import { NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, effect, inject } from '@angular/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { ApplicationInsightsService } from '@elementz/telemetry';
import { environment } from '@environment/environment';
import { MaterialSymbol } from 'material-symbols';
import { SidebarStateService } from '../sidebar/sidebar-state.service';
import { ApplicationAuthService } from '../../services/application-auth.service';

@Component({
  selector: 'app-menu',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    MatListModule,
    MatIconModule,
    RouterLink,
    MatTooltipModule,
    NgTemplateOutlet,
    MatFormFieldModule,
    RouterLinkActive
  ],
  templateUrl: './menu.component.html',
  styleUrl: './menu.component.scss'
})
export class MenuComponent {
  private readonly sidebarStateService = inject(SidebarStateService);
  private readonly appInsightsService = inject(ApplicationInsightsService);
  private readonly authService = inject(ApplicationAuthService);

  readonly keyboardArrowRightIcon: MaterialSymbol = 'keyboard_arrow_right';
  readonly keyboardArrowUpIcon: MaterialSymbol = 'keyboard_arrow_up';

  expanded: { [key: string]: boolean } = {};
  $menuItems = this.sidebarStateService.currentMenu;
  $isSidebarExpanded = this.sidebarStateService.isExpanded;

  constructor() {
    effect(() => {
      if (!this.$isSidebarExpanded()) {
        this.expanded = {};
      }
    });
  }

  toggle(section: string) {
    this.expanded[section] = !this.expanded[section];
    if (!this.$isSidebarExpanded()) {
      this.sidebarStateService.toggleIsExpanded();
    }
  }

  navigateToAdmin(): void {
    window.location.href = environment.sourceApp;
  }

  signOut(): void {
    this.authService.logout();
    this.appInsightsService.clearUser();
  }
}
